import { DataPrepBody, DataPrepEnums, DataPrepSymbol } from 'dashboard-services/api/dataPrep';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { ActionService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { globalActions } from 'primary-components';

import { basicDataStorageCreatorActions, builderDataStorageCreatorActions } from 'actions/modules/dataStorage/creator';
export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_SAVE_DIALOG_DATA_STORAGE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const getInitConfigObjFromState = () => (_, getState) => {
    const {
      dataRange,
      lastTypeOnTimeTimezone,
      holidayCalendar,
      lastTypeOnTime,
      lastValue,
      lastType,
      deltaTransDateLimitType,
      deltaTransDateLimitAmount,
      decimalPlaces,
      skipEmptyColumns,
      delta,
      outputLayout,
      withType,
      attachMetadataToNcsv,
      failOnMissingSymbols,
      ncsvEmptySymbolsInResult,
      dateFormat,
      timezone,
      roundingMode,
      fromSelected,
      from,
      fromTime,
      toSelected,
      to,
      toTime,
      basket,
      order
    } = getState().dataStorageState.creatorState.builderState
    return {
      dataRange,
      lastTypeOnTimeTimezone,
      holidayCalendar,
      lastTypeOnTime,
      lastValue,
      lastType,
      deltaTransDateLimitType,
      deltaTransDateLimitAmount,
      decimalPlaces,
      skipEmptyColumns,
      delta,
      outputLayout,
      withType,
      attachMetadataToNcsv,
      failOnMissingSymbols,
      ncsvEmptySymbolsInResult,
      dateFormat,
      timezone,
      roundingMode,
      fromSelected,
      from,
      fromTime,
      toSelected,
      to,
      toTime,
      basket,
      order
    }
  }

  const getPreparedBasket = ({ id, name: defaultName, groupName: defaultGroupName } = {}) => (_, getState) => {
    const { attachMetadataToNcsv, basket, corrections, dataRange, dateFormat, decimalPlaces, delta, failOnMissingSymbols, from, fromSelected, fromTime, holidayCalendar, lastType, lastTypeOnTime, lastTypeOnTimeTimezone, lastValue, deltaTransDateLimitType, deltaTransDateLimitAmount, ncsvEmptySymbolsInResult, order, outputLayout, roundingMode, skipEmptyColumns, timezone, to, toSelected, toTime, withType, withWareHouseService } = getState().dataStorageState.creatorState.builderState,
          isGroupFilterApplied = builderDataStorageCreatorActions.isGroupFilterApplied(basket)
    let symbols, builder = new DataPrepBody.Builder()
    if(isGroupFilterApplied) {
      symbols = []
      builder = builder.withDataGroupName(basket[0]?.groupName)
    } else {
      symbols = basket.map(item => 
        new DataPrepSymbol.Builder()
          .withValueColumnNames(item.choosenColumns?.map(i => i?.value))
          .withSymbol(item.symbols)
          .withMetadata(item.pattern ? item.metadata : undefined)
          .withGroupName(item.groupName)
          .withOffsetAmount(item.offsetAmount)
          .withOffsetType(item.offsetType)
          .withFillType(item.fillType)
          .withAvgPointsAmount(item.avgPointsAmount)
          .withPattern(item.pattern)
          .withPatternExactMatch(item.patternExactMatch)
          .withSymbolValuesExactMatch(item.symbolValuesExactMatch)
          .withSource(item.source)
          .build()
          .serialize()
    )
    }
    const name = defaultName || getState().dataStorageState.creatorState.saveDialogState.name
    const groupName = defaultGroupName || getState().dataStorageState.creatorState.saveDialogState.groupName
    const outputLayoutFinal = outputLayout?.value || outputLayout
    return builder
      .withId(id)
      .withDateFormat(dateFormat)
      .withName(name)
      .withSymbols(symbols)
      .withRange(dataRange)
      .withDateFrom(fromSelected === DataStorageEnums.DATE_BETWEEN_TYPE.DATE ? `${from}T${resolveTime(fromTime)}` : fromSelected)
      .withDateTo(toSelected === DataStorageEnums.DATE_BETWEEN_TYPE.DATE ? `${to}T${resolveTime(toTime)}` : toSelected)
      .withLastType(lastType)
      .withLastTypeAmount(lastValue)
      .withLastTypeOnTime(lastTypeOnTime)
      .withLastTypeOnTimeTimezone(lastTypeOnTimeTimezone)
      .withDeltaTransDateLimitType(deltaTransDateLimitType)
      .withDeltaTransDateLimitAmount(deltaTransDateLimitAmount)
      .withHolidayCalendar(holidayCalendar)
      .withOutputLayout(outputLayoutFinal === DataPrepEnums.OUTPUT_LAYOUT.NCSV ? DataPrepEnums.OUTPUT_LAYOUT.FAST_NCSV : outputLayoutFinal)
      .withOutputGroup(groupName)
      .withTimezone(timezone)
      .withAttachMetadataToNcsv(attachMetadataToNcsv)
      .withType(withType)
      .withDecimalPrecision(decimalPlaces === "" ? undefined : decimalPlaces)
      .withRoundingMode(roundingMode)
      .withFailOnMissingSymbols(failOnMissingSymbols)
      .withNcsvEmptySymbolsInResult(ncsvEmptySymbolsInResult)
      .withSkipEmptyColumns(skipEmptyColumns)
      .withDelta(delta)
      .withCorrections(corrections)
      .withOrder(order)
      .withSource(withWareHouseService ? "WarehouseService" : null)
      .build()
      .serialize();
  }

  const resolveTime = time => {
    if(time === undefined || time === "") {
      return "00:00:00"
    } else if(String(time).length === 2) {
      return time + ":00:00.000"
    } else if(String(time).length === 5) {
      return time + ":00.000"
    } else if(String(time).length === 8) {
      return time + ".000"
    }
    return time;
  }

  const getSearchWithoutSourceId = toSearch => toSearch.replace(/(?:&sourceId=.*?)[^#|&]+/g, '')

  const saveDataPrepCore = ({ createCall, updateCall, navigate, name: defaultName, groupName: defaultGroup, id, closeDialog, shouldUpdate }) => (dispatch, getState) => {
    const saveDialogState = getState().dataStorageState.creatorState.saveDialogState,
          dataPrepName = String(defaultName || saveDialogState.name).trim(),
          dataPrepGroup = String(defaultGroup || saveDialogState.groupName).trim(),
          basket = dispatch(getPreparedBasket({ id, name: dataPrepName, groupName: dataPrepGroup }))
    dispatch(basicDataStorageCreatorActions.changeValue(true, 'saved'))
    return (shouldUpdate ? updateCall({ id, dataPrep: basket }) : createCall({ dataPrep: basket }))
      .then(response => {
        dispatch(basicDataStorageCreatorActions.changeValue(response?.id, 'id'))
        dispatch(changeValue(dataPrepGroup, "groupName"))
        dispatch(changeValue(dataPrepName, 'name'))
        dispatch(builderDataStorageCreatorActions.changeValue(dispatch(getInitConfigObjFromState()), 'initConfigObj'))
        return response;
      })
      .then(response => {
        const hash = window.location.hash
        const search = window.location.search
        const url = DashboardLinkFactory.dataStorage.dataPrep({ baseUrl: "", groupName: dataPrepGroup, name: dataPrepName, rawQuery: getSearchWithoutSourceId(search), storageScreen: hash ? hash.substring(1) : null, version: "latest" })
        if(decodeURI(window.location.pathname) !== url) {
          navigate(url, { replace: true })
        }
        closeDialog?.()
        return response;
      })
    }
  
  const save = ({ createCall, updateCall, navigate, groupName, name, closeDialog }) => (dispatch, getState) => {
    const id = getState().dataStorageState.creatorState.basicState.id
    return dispatch(saveDataPrepCore({ createCall, updateCall, navigate, groupName, name, closeDialog, shouldUpdate: !!id, id }))
      .then(response => {
        dispatch(globalActions.getMessageStore()).success("Data prep has been saved.")
        return response.id;
      })
  }

  const copy = ({ createCall, updateCall, navigate, name, groupName, closeDialog }) => dispatch => 
    dispatch(saveDataPrepCore({ createCall, updateCall, navigate, name, groupName, closeDialog, shouldUpdate: false }))
      .then(response => {
        dispatch(globalActions.getMessageStore()).success("New Data prep has been created.")
        return response.id;
      })

  const move = ({ createCall, updateCall, navigate, groupName, closeDialog }) => (dispatch, getState) =>
    dispatch(saveDataPrepCore({ createCall, updateCall, navigate, groupName, closeDialog, id: getState().dataStorageState.creatorState.basicState.id, shouldUpdate: true }))
      .then(response => {
        dispatch(globalActions.getMessageStore()).success("Data prep has been moved to the new group.")
        return response.id;
      })

  const edit = ({ createCall, updateCall, navigate, name, closeDialog }) => (dispatch, getState) => 
    dispatch(saveDataPrepCore({ createCall, updateCall, navigate, name, closeDialog, id: getState().dataStorageState.creatorState.basicState.id, shouldUpdate: true }))
      .then(response => {
        dispatch(globalActions.getMessageStore()).success("Data prep has been saved.")
        return response.id;
      })

  const saveAs = () => (dispatch, getState) => {
    const executing = getState().dataStorageState.creatorState.basicState.executing
    if(executing) {
      return;
    }
    dispatch(changeValue(true, "isOpen"))
  }

  const quickSave = ({ createCall, updateCall, navigate }) => (dispatch, getState) => {
    const executing = getState().dataStorageState.creatorState.basicState.executing,
          id = getState().dataStorageState.creatorState.basicState.id
    if(executing) {
      return;
    }
    if(id) {
      dispatch(save({ createCall, updateCall, navigate }))
    } else {
      dispatch(changeValue(true, "isOpen"))
    }
  }

  const getNameValidators = (errors = []) => [{
    message: errors?.find(e => e.field === "name")?.message || "",
    validator: () => errors?.findIndex(e => e.field === "name") === -1
  }]

  const getGroupNameValidators = (errors = []) => [{
    message: errors?.find(e => e.field === "outputGroup")?.message || "",
    validator: () => errors?.findIndex(e => e.field === "outputGroup") === -1
  }]

  return {
    changeValue,
    CHANGE_VALUE,
    save,
    copy,
    getPreparedBasket,
    quickSave,
    saveAs,
    getNameValidators,
    getGroupNameValidators,
    move,
    edit
  }
})()
